import { useMemo } from 'react'

import { Info } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { GuidelineFormValues } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

const imageMap = {
  row: {
    fileName: 'row-guidelines.png',
    message: 'entire rows only',
  },
  column: {
    fileName: 'column-guidelines.png',
    message: 'entire columns only',
  },
  cell: {
    fileName: 'cell-guidelines.png',
    message: 'specific cells',
  },
}

export const ImagePreview: React.FC = () => {
  const { watch } = useFormContext<GuidelineFormValues>()

  const values = watch()

  const imageConfig: (typeof imageMap)[keyof typeof imageMap] | null = useMemo(() => {
    if (!values.value_column) {
      return null
    }

    if (!Object.keys(values.identifiers ?? {}).length) {
      return imageMap.column
    }

    return imageMap.cell
  }, [values.value_column, values.identifiers])

  return (
    imageConfig && (
      <div
        className={
          'border bg-white border-blue-300 rounded-lg p-4 gap-4 flex items-center justify-center'
        }
      >
        <div className="flex items-center justify-center flex-col gap-2 text-blue-400">
          <Info strokeWidth={1.5} size={30} />
          <span className={'text-sm max-w-55 text-center'}>
            This guideline is targeting
            <br />
            <strong>{imageConfig.message}</strong>
          </span>
        </div>
        <div className={'inline-flex w-40'}>
          <img
            src={`/images/${imageConfig.fileName}`}
            alt={'Guideline type image preview'}
            loading="lazy"
            decoding="async"
            className={'h-full object-contain'}
          />
        </div>
      </div>
    )
  )
}
